export default __webpack_public_path__ + "static/5-ddf36f52713c7e5483d20bd08a75bf64.webp";